import { useEffect, useState } from 'react';
import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { RateCalendarModel } from 'src/common/models/common/rate-calendar-model';

import { DayName, renderDatePicker, UitkDateFieldProps } from 'uitk-react-date-picker';

export interface DatepickerProps {
  controls?: any;
  datePickerAnalytics?: any;
  dateType?: string;
  endDate?: string;
  fetchDatePickerRates?: () => Promise<RateCalendarModel>;
  midnightBookingOffsetHours?: any;
  numDaysBookableInAdvance?: number;
  startDate?: string;
  textValues?: any;
}
export interface DatePickerState {
  rates?: RateCalendarModel;
}
export const Datepicker: React.FunctionComponent<UitkDateFieldProps & DatepickerProps> = ({
  controls,
  datePickerAnalytics,
  dateType,
  endDate,
  fetchDatePickerRates,
  midnightBookingOffsetHours,
  numDaysBookableInAdvance,
  startDate,
  textValues
}) => {
  const l10n = useLocalization();
  const [pickerState, setPickerState] = useState({} as RateCalendarModel['datePickerContent']);

  useEffect(() => {
    if (fetchDatePickerRates && typeof fetchDatePickerRates === 'function') {
      fetchDatePickerRates().then(rates => {
        if (rates && typeof rates === 'object') {
          setPickerState(rates.datePickerContent);

          const disclaimer = rates.disclaimer;
          if (disclaimer) {
            const calendar = document.querySelector('.uitk-calendar');
            const legalDisclaimer = document.createElement('div');
            legalDisclaimer.textContent = disclaimer;
            legalDisclaimer.className =
              'uitk-type-200 all-b-padding-six uitk-type-center all-l-padding-three all-r-padding-three all-t-padding-three';
            calendar.insertBefore(legalDisclaimer, calendar.firstChild);
          }
        }
      });
    }
  }, []);

  return renderDatePicker(
    dateType,
    startDate,
    endDate,
    numDaysBookableInAdvance,
    midnightBookingOffsetHours,
    datePickerAnalytics,
    controls,
    textValues,
    DayName[l10n.getWeekData().firstDay.toUpperCase()],
    pickerState
  );
};
Datepicker.displayName = 'Datepicker';
